import styled from 'styled-components';

export const Container = styled.h1`
  font-size: 1.5rem;
  text-transform: capitalize;
  margin: 0 0 30px 0;

  @media (min-width: 768px) {
    font-size: 34px;
  }
`;
